import { THEME } from '../config/commons';
import { getUserSession } from '../utils/userSession';

export const getCurrentTheme = () => {
  const userSession = getUserSession();
  return userSession?.theme || THEME.DARK;
};
